import { createPrng } from '@play-co/replicant';
import { MutableState } from '../State';
import { cardsAddCard } from '../cards/cards.modifiers';
import { CardPackID, CardPackTier, cardPackConfig } from './cardpack.ruleset';
import { getCardPackContents } from './cardpack.utils';

function grantCardPack(state: MutableState, id: CardPackID) {
  state.inventory.cardPacks[id] = state.inventory.cardPacks[id] ?? {
    count: 0,
  };
  state.inventory.cardPacks[id].count++;
}

export function openCardPack(state: MutableState, id: CardPackID, now: number) {
  const packsAvailable = state.inventory.cardPacks[id]?.count ?? 0;

  if (!packsAvailable) {
    throw new Error(`No packs available: ${id}`);
  }

  // No good reason to bloat the state
  if (packsAvailable === 1) {
    delete state.inventory.cardPacks[id];
  } else {
    state.inventory.cardPacks[id].count--;
  }

  const contents = getCardPackContents(id, state.id, now);

  for (const cardId of contents) {
    cardsAddCard(state, { cardId, now });
  }

  return contents;
}

export function grantCardPackByTier(
  state: MutableState,
  tier: CardPackTier,
  now: number,
): void {
  const available = Object.entries(cardPackConfig)
    .filter(([_, config]) => config.tier === tier)
    .map(([id]) => id) as CardPackID[];

  const random = createPrng(`${state.id}-${now}`);
  const selectedId = available[(random() * available.length) | 0];
  grantCardPack(state, selectedId);
}
